export default __webpack_public_path__ + "static/media/ico_arrow_down_blue.2a2bc6ab.svg";